import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Pagetitle from "../elements/Pagetitle";
import Portfolio from "../elements/Portfolio";

const filters = [
  {
    id: 1,
    text: "Everything",
  },
  {
    id: 2,
    text: "Reports",
  },
  {
    id: 3,
    text: "Health",
  },
  {
    id: 4,
    text: "Jobs",
  },
  {
    id: 5,
    text: "Party",
  },
  {
    id: 6,
    text: "Oil and Gas",
  },
  {
    id: 7,
    text: "Real State",
  },
  {
    id: 8,
    text: "Software",
  },
];

const allData = [
  {
    id: 10,
    title: "Querify",
    category: "Software",
    image: "images/portfolio/querify/querify-logo.svg",
    popupLink: [
      "https://www.youtube.com/watch?v=PXwoZzKA73E",
      "images/portfolio/querify/auth-screen.png",
      "images/portfolio/querify/og-image.png",
    ],
    imgStyle: { width: "100%", height: 200, padding: 25, objectFit: "contain" },
    content: {
      segment: "Multi-tenant SaaS knowledge platform",
      frontend: "React 19, TypeScript, Vite, Tailwind CSS v4, TanStack Query, TanStack Table, Auth0 SPA SDK",
      backend: ".NET 10, ASP.NET Core, EF Core, MediatR, PostgreSQL, Auth0 JWT, RabbitMQ, MassTransit, Hangfire, SignalR, Redis",
      plataform: "Docker Compose, S3-compatible storage, OpenTelemetry, Jaeger, Prometheus, Grafana, Sentry, Swagger/OpenAPI",
      demoLink: "http://dev.portal.querify.net/",
      description: "Querify transforms recurring questions into reusable knowledge assets for self-service, support, community response, and governed decision workflows. I built the platform around a React tenant Portal, modular .NET APIs, tenant-aware PostgreSQL persistence, background workers, realtime notifications, and an AI/MCP-ready architecture.",
    }
  },
  {
    id: 1,
    title: "SafeDynamicAPI",
    category: "Software",
    image: "images/portfolio/safe-dynamic-api/logo.png",
    popupLink: [
      "images/portfolio/safe-dynamic-api/backend-users-1.png",
      "images/portfolio/safe-dynamic-api/demo-frontend-1.png",
      "images/portfolio/safe-dynamic-api/backend-permissions-1.png",
      "images/portfolio/safe-dynamic-api/backend-sqlmanager-1.png",
      "images/portfolio/safe-dynamic-api/backend-logger-1.png",
    ],
    imgStyle: { width: "auto", height: 220, marginTop: -10 },
    content: {
      segment: "Software Development",
      frontend: "HTML5, CSS3, Javascript, Docusaurus, Markdown, React, Redux and Sass",
      backend: "PHP, Laravel, NodeJs, MySQL, SqlServer, PostgreeSQL, Sqlite, JWT and Social integrations",
      plataform: "Shared hosts, Vercel and Github",
      description: "Automatic API generator with its own authentication or via facebook, google, github, twitter, bitbucket or linkedin with custom MySQL/MariaDB, PostgreSQL, SQL Server functions and permissions with source code SQLite databases.",
    }
  },
  {
    id: 2,
    title: "Coronavirus Tracker Dashboard",
    category: "Health",
    image: "images/portfolio/coronavirus-tracker-map-dashboard/logo.svg",
    popupLink: [
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-1.png",
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-2.png",
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-3.png",
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-4.png",
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-5.png",
      "images/portfolio/coronavirus-tracker-map-dashboard/coronavirus-tracker-6.png",
    ],
    content: {
      segment: "Health",
      frontend: "HTML5, CSS4 and Javascript",
      backend: "React, D3 chart and Bootstrap 4",
      plataform: "Github Pages and NodeJs",
      description: "Coronavirus Tracker is a project developed with javascript, ReactJs, D3 chart and Bootstrap to generate coronavirus graphics and dashboards.",
    }
  },
  {
    id: 3,
    title: "Excel to Word/PDF Auto Report",
    category: "Reports",
    image: "images/portfolio/excel-to-word-auto-report/logo.svg",
    popupLink: [
      "images/portfolio/excel-to-word-auto-report/sample-report-template-1.jpg",
      "images/portfolio/excel-to-word-auto-report/sample-generated-report-1.jpg",
    ],
    content: {
      segment: "Reports",
      frontend: "HTML5, CSS4, Swagger and Javascript",
      backend: "C#, WebAPI, Office Interop",
      plataform: "Console",
      description: "ExcelToWordAutoReport is a project developed with .Net Core with the C# language to generate reports from the Microsoft Office Interop library. The input data of the report is loaded from an excel file and the output format of the report can be chosen between Word and PDF.",
    }
  },
  {
    id: 4,
    title: "EZLIV",
    category: "Health",
    image: "images/portfolio/ezliv/logo-ezliv.svg",
    popupLink: [
      "images/portfolio/ezliv/ezliv-02.png",
      "images/portfolio/ezliv/ezliv-03.png",
      "images/portfolio/ezliv/ezliv-04.png",
      "images/portfolio/ezliv/ezliv-05.png",
      "images/portfolio/ezliv/ezliv-report.png",
    ],
    imgStyle: { padding: 0 },
    content: {
      segment: "Health and Insurance.",
      frontend: "Angular, HTML5, CSS3, Razor, Javascript, Gulp, Bootstrap and Jquery.",
      backend: "C#, .NET Framework, Multi Tenancy, SignalR, WebAPI, AspNetBoilerplate, DDD, TDD, Background Job, Hangfire, Entity Framework, and SQL Server",
      plataform: "Azure App Service, Azure SQL databases, Amazon EC2 (Pipeline Agent) and Azure DevOps (Repository and Production Pipelines)",
      description: "EZLiv was a startup that offered health and insurance plans that were contracted entirely online, an innovation in 2017 after the release of ANS (National Supplementary Health Agency of Brazil) to sell health plans online. I worked as Leader Software engineer, led teams and developed the main backend and frontend systems, refined tasks between customers and the development team and integrated the other departments of the company.",
    }
  },
  {
    id: 5,
    title: "Job2p",
    category: "Jobs",
    image: "images/portfolio/job2p/job2p-logo.png",
    popupLink: [
      "https://www.youtube.com/watch?v=5q273qa2NFY",
      "images/portfolio/job2p/job2p-desktop-1.png",
      "images/portfolio/job2p/job2p-desktop-2.png",
      "images/portfolio/job2p/job2p-mobile.png",
    ],
    imgStyle: { width: "initial", height: 135, marginTop: 35 },
    content: {
      segment: "Jobs",
      frontend: "HTML5, CSS3, Razor Pages, Javascript, Gulp, Bootstrap and Jquery. UI based on job market giants like Monster, Indeed and Google.",
      backend: "C#, .NET Core, Multi Tenancy, SignalR, NodeJs, WebAPI, AspNetBoilerplate, Background Job, Hangfire, Entity Framework and SQL Server",
      plataform: "Azure App Service, Azure SQL databases and Azure DevOps (Repository and Pipelines)",
      description: "Job2p is the job site for candidates and employers. It uses robots to index vacancies from the internet in its database and also offers the option for employers to manage vacancies in a multi tenant structure that protects the data of each company. The user interface and user experience were created based on renowned job sites like Monster, Indeed and Google Jobs.",
    }
  },
  {
    id: 6,
    title: "My Gender Reveal Party",
    category: "Party",
    image: "images/portfolio/mygenderrevealparty/mygenderrevealparty-main.png",
    popupLink: [
      "https://www.youtube.com/watch?v=dcZX8Yd9OA0",
      "images/portfolio/mygenderrevealparty/mygenderrevealparty-main.png",
      "images/portfolio/mygenderrevealparty/mygenderrevealparty-votes.png",
      "images/portfolio/mygenderrevealparty/mygenderrevealparty-mobile.png",
    ],
    imgStyle: { padding: 0, margin: 0, width: "100%" },
    content: {
      segment: "Gender Reveal Party",
      frontend: "HTML5, CSS3, Razor Pages, Javascript, Gulp, Bootstrap and Jquery",
      backend: "C#, .NET Core, Multi Tenancy, SignalR, NodeJs, WebAPI, AspNetBoilerplate, Entity Framework and SQL Server",
      plataform: "Azure App Service, Azure SQL databases and Azure DevOps (Repository and Pipelines)",
      description: "The My Gender Reveal Party project was developed to facilitate the voting of my family members who live in Brazil, my wife's family who live in Russia and our friends who could not be present who live in Canada. Everyone was able to vote in their respective languages (English, Brazilian Portuguese and Russian). Whoever went to the party saw the voting in real time through an IPAD, which was showing the votes of those who connected anywhere in the world.",
    }
  },
  {
    id: 7,
    title: "Real State",
    category: "Real State",
    image:
      "images/portfolio/realestatedevelopment1/real-estate-development-1.png",
    popupLink: [
      "images/portfolio/realestatedevelopment1/real-estate-development-1.png",
      "images/portfolio/realestatedevelopment1/real-estate-development-2.png",
      "images/portfolio/realestatedevelopment1/real-estate-development-mobile-1.png",
      "images/portfolio/realestatedevelopment1/real-estate-development-mobile-2.png",
    ],
    imgStyle: { padding: 0, margin: 0, width: "100%" },
    content: {
      segment: "Real Estate",
      frontend: "HTML5, CSS3, Javascript, Bootstrap and Jquery",
      backend: "PHP, Wordpress and MySql",
      plataform: "Azure App Service, Azure Mysql and Azure DevOps (Repository and Pipelines)",
      description: "Content management system in Brazilian Portuguese to provide details on the commercialization of commercial rooms within a new mall in Rio de Janeiro and related investments. The main site was used only frontend technologies and for the news part the content manager Wordpress was used, with a template created from scratch and stylized with the company's visual identity.",
    }
  },
  {
    id: 8,
    title: "Frontend - Oil and gas drilling",
    category: "Oil and Gas",
    image: "images/portfolio/oilandgascompany1/oilandgascompany1-1.png",
    popupLink: [
      "images/portfolio/oilandgascompany1/oilandgascompany1-1.png",
      "images/portfolio/oilandgascompany1/oilandgascompany1-2.png",
    ],
    imgStyle: { padding: 0, margin: 0, width: "100%" },
    content: {
      segment: "Oil and Gas",
      frontend: "HTML5, CSS4, Javascript and Typescript",
      framework: "React, React redux, D3 charts, Material Design UI, Highcharts",
      plataform: "Nginx, NodeJs and AWS S3",
      description: "Front-end development for an oil and gas company to create a drilling management module with or without artificial intelligence, graphics with good usability practices, real-time option, good performance practices and projection screens for the Web and mobile devices.",
    }
  },
  {
    id: 9,
    title: "CMS - Oil and gas company",
    category: "Oil and Gas",
    image: "images/portfolio/oilandgascompany2/oil-and-gas-company-2-cms-1.png",
    popupLink: [
      "images/portfolio/oilandgascompany2/oil-and-gas-company-2-cms-1.png",
      "images/portfolio/oilandgascompany2/oil-and-gas-company-2-cms-2.png",
      "images/portfolio/oilandgascompany2/oil-and-gas-company-2-cms-3.png",
      "images/portfolio/oilandgascompany2/oil-and-gas-company-2-filesystem.png",
    ],
    imgStyle: { padding: 0, margin: 0, width: "100%" },
    content: {
      segment: "Oil and Gas",
      frontend: "HTML5, CSS3, Angular 6, Node, Javascript and Typescript",
      backend: "C#, .NET Core, AspNetBoilerplate, WebAPI, SQL Server, DDD and TDD",
      plataform: "Amazon Services (EC2, EBS and S3),",
      description: "Technical leadership and front-end and back-end development for oil and gas company for business rules, file systems management and content management integrated with Amazon.",
    }
  },
];

const getItemsByFilter = (items, filter) => {
  if (filter === filters[0].text.toLowerCase()) {
    return items;
  }

  return items.filter((data) => data.category.toLowerCase() === filter);
};

function Works() {
  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    const defaultFilter = filters[0].text.toLowerCase();

    setActiveFilter(defaultFilter);
    setVisibleItems(getItemsByFilter(getAllItems, defaultFilter).slice(0, dataVisibleCount));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    e.preventDefault();

    const nextFilter = e.target.textContent.toLowerCase();
    const nextItems = getItemsByFilter(getAllItems, nextFilter);

    setActiveFilter(nextFilter);
    setVisibleItems(nextItems.slice(0, dataVisibleCount));
    setNoMorePost(dataVisibleCount >= nextItems.length);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    const tempCount = dataVisibleCount + dataIncrement;
    const filteredItems = getItemsByFilter(getAllItems, activeFilter);

    if (dataVisibleCount >= filteredItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      setVisibleItems(filteredItems.slice(0, tempCount));
      setNoMorePost(tempCount >= filteredItems.length);
    }
  };

  return (
    <section id="works">
      <div className="container">
        <Pagetitle title="Portfolio" />
        {/* Start Portfolio Filters */}
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          animateOnce={true}
        >
          <ul className="portfolio-filter list-inline">
            {filters.map((filter) => (
              <li className="list-inline-item" key={filter.id}>
                <button
                  onClick={handleChange}
                  className={
                    filter.text.toLowerCase() === activeFilter
                      ? "text-capitalize current"
                      : "text-capitalize"
                  }
                >
                  {filter.text}
                </button>
              </li>
            ))}
          </ul>
        </ScrollAnimation>
        {/* End Portfolio Filters */}

        {/* Start Portfolio Items */}
        <div className="row portfolio-wrapper">
          {visibleItems.map((item) => (
            <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
              <Portfolio portfolio={item} />
            </div>
          ))}
        </div>
        {/* End Portfolio Items */}

        <div className="load-more text-center mt-4">
          <button
            className="btn btn-default"
            onClick={handleLoadmore}
            disabled={noMorePost ? "disabled" : null}
          >
            {noMorePost ? (
              "No more items"
            ) : (
              <span>
                <i className="fas fa-spinner"></i> Load more
              </span>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Works;
